<template>
  <div class="choose-country" @click="dispatch('open')" :country="entity">
    <span class="flag"
      ><img
        :src="require('@/' + `assets/changeCountry/flag-${entity}.svg`)"/></span
    ><span class="country">{{ country }}</span>
  </div>
</template>

<script>
import { entity } from '@/../region.json';

export default {
  props: ['dispatch'],
  data() {
    return { entity };
  },
  computed: {
    country() {
      return this.$i18n.t(`change_country.${this.entity.toLowerCase()}`);
    },
  },
};
</script>

<style scoped>
.choose-country {
  margin-top: 20px;
  display: grid;
  grid-template-columns: auto 15px 1fr;
  align-items: center;
  cursor: pointer;
}
.flag {
  grid-column: 1;
}
.flag img {
  min-width: 30px;
}
.country {
  grid-column: 3;
  color: white;
}
</style>
